import React from "react";
import { withRouter } from "react-router-dom";
import ClientsPage from "../multiUserManagementClients/ClientsPage";

function AdminsPage(props) {
  return <ClientsPage type={"admin"} />;
}

export default withRouter(AdminsPage);
